import { Outlet } from "react-router-dom";

// El sondeo de notificaciones (avisos, avisos de pago, reservaciones) y los
// toasts viven ahora en NotificationProvider/NotificationToasts, montados una
// sola vez en Layout — así cubren también al admin, no solo al residente.
export default function PortalShell() {
  return <Outlet />;
}
